import WorkbookPracticeWorkspace from "./WorkbookPracticeWorkspace";

export default WorkbookPracticeWorkspace;
